module.exports = __webpack_public_path__ + "static/img/logo-dep.759f21ab.png";